import styled from 'styled-components';

interface FlexBoxProps {
  $direction?: string;
  $alignItems?: string;
  $justifyContent?: string;
}

const FlexBox = styled.div<FlexBoxProps>`
  display: flex;
  flex-direction: ${(props) => props.$direction || 'row'};
  align-items: ${(props) => props.$alignItems || 'flex-start'};
  justify-content: ${(props) => props.$justifyContent || 'center'};
`;

export default FlexBox;
